import Navbar from './components/Navbar';
import Footer from './components/Footer';
import './App.css';

function ContactUs() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <div className="mt-16 md:mt-24 py-12 md:py-16 bg-white">
        <div className="max-w-[1200px] mx-auto px-4 md:px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16">
            {/* Left Column - Contact Form */}
            <div>
              <h1 className="text-3xl md:text-5xl uppercase italic tracking-wider mb-8 md:mb-12 font-light">
                CONTACT US
              </h1>

              <form className="space-y-6">
                <div>
                  <label className="block text-sm font-semibold mb-2">Name</label>
                  <div className="grid md:grid-cols-2 gap-4">
                    <div>
                      <input 
                        type="text" 
                        placeholder="First Name (required)"
                        className="w-full px-4 py-3 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500"
                      />
                    </div>
                    <div>
                      <input 
                        type="text" 
                        placeholder="Last Name (required)"
                        className="w-full px-4 py-3 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500"
                      />
                    </div>
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-semibold mb-2">Email Address (required)</label>
                  <input 
                    type="email" 
                    className="w-full px-4 py-3 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500"
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold mb-2">Subject (required)</label>
                  <input 
                    type="text" 
                    className="w-full px-4 py-3 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500"
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold mb-2">Message (required)</label>
                  <textarea 
                    rows="6"
                    className="w-full px-4 py-3 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500"
                  ></textarea>
                </div>

                <button 
                  type="submit"
                  className="border-2 border-black text-black px-12 py-3 hover:bg-black hover:text-white transition-colors uppercase text-sm font-bold tracking-widest"
                >
                  SUBMIT
                </button>
              </form>
            </div>

            {/* Right Column - Contact Info */}
            <div>
              <h2 className="text-3xl md:text-5xl uppercase italic tracking-wider mb-6 md:mb-8 font-light" style={{ color: '#F5A623' }}>
                THROTTLE EDGE
              </h2>

              <div className="space-y-6 text-gray-800 mb-8">
                <div>
                  <p>Throttle Edge</p>
                  <p>Islamabad, Pakistan</p>
                </div>

                <div>
                  <p className="font-bold mb-2">Pro-Shop/Track/General Inquiries:</p>
                  <a href="mailto:info@throttledge.com" className="text-red-600 hover:underline">
                    info@throttledge.com
                  </a>
                </div>

                <div>
                  <p className="font-bold mb-2">Service/Parts Inquiries:</p>
                  <a href="mailto:orders@throttledge.com" className="text-red-600 hover:underline">
                    orders@throttledge.com
                  </a>
                </div>

                <div>
                  <p className="font-bold mb-2">Phone number:</p>
                  <p>+92-51-1234567</p>
                </div>
              </div>

              {/* Map */}
              <div className="mb-8">
                <iframe 
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2943.123456789!2d-80.5!3d42.8!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDLCsDQ4JzAwLjAiTiA4MMKwMzAnMDAuMCJX!5e0!3m2!1sen!2sca!4v1234567890"
                  width="100%"
                  height="300"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  className="border border-gray-300"
                ></iframe>
              </div>
            </div>
          </div>

          {/* Daily Costs Section */}
          <div className="mt-12 md:mt-16 pt-12 md:pt-16 border-t-2 border-gray-300">
            <h2 className="text-2xl md:text-4xl uppercase italic tracking-wider mb-6 md:mb-8 font-light" style={{ color: '#F5A623' }}>
              DAILY COSTS
            </h2>
            <div className="space-y-3 text-gray-800">
              <p>Dirt bikes or ATV's = PKR 7,245 per rider.</p>
              <p>Side by sides = PKR 9,315 per driver.</p>
              <p>Passenger in a proper 2-up seat or in a SXS = PKR 4,140 per passenger.</p>
              <p>Golf Cart = PKR 5,175 per driver.</p>
            </div>
          </div>

          {/* Track Conditions Section */}
          <div className="mt-12 md:mt-16 pt-12 md:pt-16 border-t-2 border-gray-300">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16">
              <div>
                <h2 className="text-4xl uppercase italic tracking-wider mb-8 font-light" style={{ color: '#F5A623' }}>
                  TRACK CONDITIONS
                </h2>
              </div>
              <div className="space-y-3 text-gray-800">
                <p>Monday - Closed</p>
                <p>Tuesday - Groomed</p>
                <p>Wednesday - Rough</p>
                <p>Thursday - Rough and watered</p>
                <p>Friday - Groomed</p>
                <p>Saturday - Groomed and watered</p>
                <p>Sunday - Groomed and watered</p>
              </div>
            </div>
          </div>

          {/* Parts Section */}
          <div className="mt-16 pt-16 border-t-2 border-gray-300">
            <div className="grid md:grid-cols-2 gap-16">
              <div>
                <h2 className="text-4xl uppercase italic tracking-wider mb-8 font-light" style={{ color: '#F5A623' }}>
                  PARTS
                </h2>
              </div>
              <div className="space-y-4 text-gray-800">
                <p>We have a vast selection of parts available in our Pro Shop.</p>
                <p>If we don't have what you're looking for, we'll order it in! Most special order parts will arrive within 2-4 business days.</p>
              </div>
            </div>
          </div>

          {/* Nearby Services */}
          <div className="mt-16 pt-16 border-t-2 border-gray-300">
            <div className="grid md:grid-cols-2 gap-16">
              <div>
                <h3 className="text-4xl uppercase italic tracking-wider mb-8 font-light" style={{ color: '#F5A623' }}>
                  RESTAURANTS
                </h3>
              </div>
              <div className="space-y-2 text-sm text-gray-800">
                <p>Local Restaurants - Islamabad, Pakistan</p>
                <p>Pizza Max - F-7 Markaz, Islamabad</p>
                <p>Monal Restaurant - Pir Sohawa Road, Islamabad</p>
                <p>Burning Brownie - F-6 Markaz, Islamabad</p>
                <p>Street 1 Cafe - F-7 Markaz, Islamabad</p>
                <p>The Monal - Daman-e-Koh, Islamabad</p>
                <p>Tuscany Courtyard - F-6 Markaz, Islamabad</p>
                <p>Des Pardes - Blue Area, Islamabad</p>
              </div>
            </div>
          </div>

          <div className="mt-16 pt-16 border-t-2 border-gray-300">
            <div className="grid md:grid-cols-2 gap-16">
              <div>
                <h3 className="text-4xl uppercase italic tracking-wider mb-8 font-light" style={{ color: '#F5A623' }}>
                  HOTELS
                </h3>
              </div>
              <div className="space-y-2 text-sm text-gray-800">
                <p>Local Hotels - Islamabad, Pakistan</p>
                <p>Serena Hotel - Khayaban-e-Suharwardy, Islamabad</p>
                <p>Marriott Hotel - Aga Khan Road, Shalimar 5, Islamabad</p>
                <p>Pearl Continental - The Mall, Club Road, Islamabad</p>
                <p>Islamabad Hotel - Jinnah Avenue, Blue Area, Islamabad</p>
                <p>Ramada by Wyndham - Convention Center, Islamabad</p>
                <p>Best Western - F-7 Markaz, Islamabad</p>
              </div>
            </div>
          </div>

          <div className="mt-16 pt-16 border-t-2 border-gray-300">
            <div className="grid md:grid-cols-2 gap-16">
              <div>
                <h3 className="text-4xl uppercase italic tracking-wider mb-8 font-light" style={{ color: '#F5A623' }}>
                  OTHER
                </h3>
              </div>
              <div className="space-y-2 text-sm text-gray-800">
                <p>Local Grocery & Services - Islamabad, Pakistan</p>
                <p>Metro Cash & Carry - I-9 Markaz, Islamabad</p>
                <p>Imtiaz Super Market - F-7 Markaz, Islamabad</p>
                <p>Utility Stores - Multiple Locations, Islamabad</p>
                <p>Al-Fatah - Blue Area, Islamabad</p>
              </div>
            </div>
          </div>

          <div className="mt-16 pt-16 border-t-2 border-gray-300">
            <div className="grid md:grid-cols-2 gap-16">
              <div>
                <h3 className="text-4xl uppercase italic tracking-wider mb-8 font-light" style={{ color: '#F5A623' }}>
                  GAS/PROPANE
                </h3>
              </div>
              <div className="space-y-2 text-sm text-gray-800">
                <p>Local Fuel Stations - Islamabad, Pakistan</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default ContactUs;
